"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEndDate = exports.setEndTime = exports.setStartTime = exports.setNotes = void 0;
function setNotes(notes) {
    return {
        type: "SetNotes",
        payload: notes,
    };
}
exports.setNotes = setNotes;
function setStartTime(startTime) {
    return {
        type: "SetStartTime",
        payload: startTime,
    };
}
exports.setStartTime = setStartTime;
function setEndTime(startTime) {
    return {
        type: "SetEndTime",
        payload: startTime,
    };
}
exports.setEndTime = setEndTime;
function setEndDate(endDate) {
    return {
        type: "SetEndDate",
        payload: endDate,
    };
}
exports.setEndDate = setEndDate;
//# sourceMappingURL=appointment-editor-actions.js.map